import React from 'react'
import { graphql } from 'gatsby'

import HoverCardGrid, {
  HoverCardGridButtonVariant,
  HoverCardGridCard,
  HoverCardGridContent,
} from 'src/components/organisms/slidersAndGrids/hoverCardGrid'
import {
  PrismicPageDataBodyHoverCardGrid,
  PrismicPageDataBodyHoverCardGridItem,
} from 'src/typings/generated/graphql'

const parseButtonVariant = (
  variant?: string | null
): HoverCardGridButtonVariant | undefined => {
  if (variant === HoverCardGridButtonVariant.link) {
    return HoverCardGridButtonVariant.link
  }
  if (variant === HoverCardGridButtonVariant.modal) {
    return HoverCardGridButtonVariant.modal
  }
  return undefined
}

type Props = { slice: PrismicPageDataBodyHoverCardGrid }

const HoverCardGridSlice = ({ slice }: Props) => {
  const { primary, items } = slice

  const content: HoverCardGridContent = {
    anchor: primary.anchor ?? undefined,
    headline: primary.headline ?? undefined,
    description: primary.description?.richText ?? undefined,
    buttonText: primary.button_text ?? undefined,
    buttonVariant: parseButtonVariant(primary.button_variant),
    buttonLink: primary.button_link ?? undefined,
    buttonModal: {
      title: primary.modal_title ?? '',
      option1Label: primary.modal_option_1_label ?? '',
      option1Link: primary.modal_option_1_link ?? undefined,
      option2Label: primary.modal_option_2_label ?? '',
      option2Link: primary.modal_option_2_link ?? undefined,
      continueText: primary.modal_continue_text ?? 'Continue',
    },
    cards: items.map(
      (item: PrismicPageDataBodyHoverCardGridItem): HoverCardGridCard => ({
        title: item.title ?? undefined,
        description: item.description?.richText ?? undefined,
        image: item.image?.gatsbyImageData ?? undefined,
        imageAlt: item.image?.alt ?? undefined,
        modalContent: item.modal_content?.richText ?? undefined,
        modalButtonText: item.modal_button_text ?? undefined,
        modalButtonVariant: parseButtonVariant(item.modal_button_variant),
        modalButtonLink: item.modal_button_link ?? undefined,
        modalButtonModal: {
          title: item.modal_title ?? '',
          option1Label: item.modal_option_1_label ?? '',
          option1Link: item.modal_option_1_link ?? undefined,
          option2Label: item.modal_option_2_label ?? '',
          option2Link: item.modal_option_2_link ?? undefined,
          continueText: item.modal_continue_text ?? 'Continue',
        },
      })
    ),
  }

  return <HoverCardGrid content={content} />
}

export default HoverCardGridSlice

export const hoverCardGridFragment = graphql`
  fragment PageDataBodyHoverCardGrid on PrismicPageDataBodyHoverCardGrid {
    primary {
      anchor
      headline
      description {
        richText
      }
      button_text
      button_variant
      button_link {
        ...BasicLinkFragment
      }
      modal_title
      modal_option_1_label
      modal_option_1_link {
        ...BasicLinkFragment
      }
      modal_option_2_label
      modal_option_2_link {
        ...BasicLinkFragment
      }
      modal_continue_text
    }
    items {
      title
      description {
        richText
      }
      image {
        gatsbyImageData
        alt
      }
      modal_content {
        richText
      }
      modal_button_text
      modal_button_variant
      modal_button_link {
        ...BasicLinkFragment
      }
      modal_title
      modal_option_1_label
      modal_option_1_link {
        ...BasicLinkFragment
      }
      modal_option_2_label
      modal_option_2_link {
        ...BasicLinkFragment
      }
      modal_continue_text
    }
  }
`
